import { Menu, MenuProps } from "@mui/material";
export type XMenuProps = MenuProps & {};
export const XMenu = (props: XMenuProps) => {
  return (
    <Menu
      {...props}
      slotProps={{
        ...props.slotProps,
        paper: {
          ...props.slotProps?.paper,
          sx: {
            borderRadius: "16px",
          },
        },
      }}
      MenuListProps={{
        ...props.MenuListProps,
        sx: {
          ...props.MenuListProps?.sx,
        },
      }}
    ></Menu>
  );
};
